<template>
  <el-dialog
    v-model="vdata.visible"
    title="调整商户结算金额"
    width="500px"
    destroy-on-close
  >
    <div
      style="
        background-color: #fafafa;
        padding: 16px 24px;
        margin-bottom: 24px;
        border-radius: 4px;
        border: 1px solid #f0f0f0;
      "
    >
      <el-row>
        <el-col :span="24">
          <span style="color: #888">商户名称：</span>
          <span style="font-weight: 500; color: #333">{{
            vdata.formData.mchName
          }}</span>
        </el-col>
      </el-row>
      <el-row style="margin-top: 8px">
        <el-col :span="24">
          <span style="color: #888">商户号：</span>
          <span style="font-weight: 500; color: #333">{{
            vdata.formData.merchant_no
          }}</span>
        </el-col>
      </el-row>
    </div>

    <el-form :model="vdata.formData" label-width="120px">
      <el-form-item label="交易日期：" required>
        <el-date-picker
          v-model="vdata.formData.trans_day"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="请选择交易日期"
          style="width: 240px"
        />
      </el-form-item>
      <el-form-item label="调整金额：" required>
        <el-input-number
          v-model="vdata.formData.offset_amount"
          :precision="2"
          placeholder="可正可负可为0，如 -12.50"
          style="width: 240px"
        />
        <div style="color: #999; font-size: 12px; margin-top: 4px">
          正数表示增加，负数表示减少
        </div>
      </el-form-item>
    </el-form>

    <template #footer>
      <span class="dialog-footer">
        <el-button @click="vdata.visible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="vdata.confirmLoading"
          @click="handleOk"
        >
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script setup>
/* global defineExpose, defineEmits */
import { reactive, getCurrentInstance } from "vue";
import { ElMessage } from "element-plus";

const { appContext } = getCurrentInstance();
const emit = defineEmits(["refresh"]);

const vdata = reactive({
  visible: false,
  confirmLoading: false,
  formData: {
    merchant_no: "",
    mchName: "",
    trans_day: "",
    offset_amount: 0,
  },
});

// 父组件调用的显示弹窗方法
function show(record) {
  // 获取当天的 YYYY-MM-DD 格式作为默认日期
  const today = new Date();
  const defaultDate =
    today.getFullYear() +
    "-" +
    String(today.getMonth() + 1).padStart(2, "0") +
    "-" +
    String(today.getDate()).padStart(2, "0");

  // 每次打开清空并初始化数据
  vdata.formData = {
    merchant_no: record.no,
    mchName: record.merchant_alias,
    trans_day: defaultDate,
    offset_amount: 0,
  };
  vdata.visible = true;
}

// 确认提交
function handleOk() {
  if (!vdata.formData.trans_day) {
    return ElMessage.error("请选择交易日期");
  }

  if (
    vdata.formData.offset_amount === null ||
    vdata.formData.offset_amount === undefined
  ) {
    return ElMessage.error("请填写调整金额");
  }

  vdata.confirmLoading = true;

  // 组装参数
  const reqData = {
    merchant_no: vdata.formData.merchant_no,
    trans_day: vdata.formData.trans_day,
    offset_amount: vdata.formData.offset_amount,
  };

  // 调用全局挂载的 api
  appContext.config.globalProperties.$api.merchant
    .adjustSettlementAmount(reqData)
    .then((res) => {
      if (res.status == 200) {
        ElMessage.success("结算金额调整成功");
        vdata.visible = false;
        emit("refresh");
      } else {
        ElMessage.error(res.message || "调整失败");
      }
    })
    .catch((err) => {
      console.error(err);
      ElMessage.error("接口请求异常");
    })
    .finally(() => {
      vdata.confirmLoading = false;
    });
}

// 将 show 方法暴露给父组件调用
defineExpose({ show });
</script>
